var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSummary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 39.4 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.4,0H10.98s-.04,.01-.06,.01c-.09,0-.18,.02-.27,.05-.03,.01-.06,.02-.09,.03-.1,.05-.2,.11-.28,.19,0,0,0,0,0,0L.29,10.27s0,0,0,0c-.08,.08-.14,.18-.19,.28-.01,.03-.02,.06-.03,.09-.03,.09-.05,.17-.05,.27,0,.02-.01,.04-.01,.06V55c0,.55,.45,1,1,1H38.4c.55,0,1-.45,1-1V1c0-.55-.45-1-1-1ZM9.98,3.41v6.57H3.41L9.98,3.41Zm27.42,50.59H2V11.98H10.98c.55,0,1-.45,1-1V2h25.42V54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1,22.21c0-.55-.45-1-1-1s-1,.45-1,1v16.28h-3.2v-10.75c0-.55-.45-1-1-1s-1,.45-1,1v10.75h-3.2v-6.6c0-.55-.45-1-1-1s-1,.45-1,1v6.6h-3.2v-10.75c0-.55-.45-1-1-1s-1,.45-1,1v10.75h-3.2v-6.6c0-.55-.45-1-1-1s-1,.45-1,1v6.6h-1.35c-.55,0-1,.45-1,1s.45,1,1,1h25.5c.55,0,1-.45,1-1s-.45-1-1-1h-1.35V22.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51,25.29c.2,.25,.49,.39,.79,.39,.21,0,.43-.07,.61-.21l4.68-3.62,4.58,3.54c.36,.28,.86,.28,1.22,0l10.49-8.09c.44-.34,.52-.96,.18-1.4s-.96-.52-1.4-.18l-9.88,7.62-4.58-3.54c-.36-.28-.86-.28-1.22,0l-5.29,4.09c-.44,.34-.52,.97-.18,1.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/summary.7a7820431090338dd416ebc98586fd9c.svg";
export { ForwardRef as ReactComponent };